import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import {
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import { FaPlus, FaRegTrashCan, FaPencil } from "react-icons/fa6";
import DeliveryForm from "./DeliveryForm";
import CustomButton from "../customButton/CustomButton";

let BASE_URL_USER;
let BASE_URL_FLORAHUB;

if (process.env.NODE_ENV === "production") {
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
} else {
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
}

const initialValues = {
  contactPersonName: "",
  contactNo: "",
  addressType: "",
  addressUnit: "",
  locality: "",
  landmark: "",
  city: "",
  state: "",
  pincode: "",
  default: false,
};

const deliverySchema = Yup.object({
  contactPersonName: Yup.string().required("required").min(2).max(30),
  contactNo: Yup.string()
    .matches(/^[6-9][0-9]{9}$/, "Must be valid number")
    .required("required"),
  addressType: Yup.string().required("required"),
  addressUnit: Yup.string().required("required"),
  locality: Yup.string(),
  landmark: Yup.string(),
  city: Yup.string().required("required"),
  state: Yup.string().required("required"),
  pincode: Yup.string().required("required").min(6).max(6),
  default: false,
});

const Delivery = ({
  data,
  orderId,
  selectedAddress,
  setSelectedAddress,
  setIsAddressSelect,
  reload,
  setReload,
  addressLoading,
  profileData,
}) => {
  const toast = useToast();
  const accessToken = localStorage.getItem("token");
  const [isAddress, setIsAddress] = useState(false);
  const [isOpen, setIsOpen] = useState(isAddress);
  const [formDisable, setFormDisable] = useState(true);
  const [formData, setFormData] = useState(initialValues);
  const [isEdit, setIsEdit] = useState(false);
  const [addressId, setAddressId] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
  });

  // console.log(
  //   "isOpen ",
  //   isOpen,
  //   " isAddress ",
  //   isAddress,
  //   " addressLoading ",
  //   addressLoading
  // );

  useEffect(() => {
    if (!addressLoading) setIsAddress(data.length === 0 ? true : false);
  }, [data, addressLoading]);

  useEffect(() => {
    if (!addressLoading) setIsOpen(isAddress);
  }, [isAddress, addressLoading]);

  const handleRadioChange = (event) => {
    setSelectedAddress(event.target.value);
    setIsAddressSelect(true);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: formData,
    validationSchema: deliverySchema,
    enableReinitialize: true,
    async onSubmit(values) {
      try {
        if (isEdit) {
          //Edit API
          await update(values);
        } else {
          await add(values);
        }
      } catch (error) {}
    },
  });

  const add = async (values) => {
    try {
      const response = await axios.post(
        `${BASE_URL_USER}/api/v1/user/add-address`,
        values,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        toast({
          title: "Address Added Successfully",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        resetForm();
        setIsOpen(false);
        setReload(!reload);
        setFormData(initialValues);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast({
          title: error?.response?.data?.errors[0]?.appMessage || "Bad Request",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something Went Wrong",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const update = async (values) => {
    if (addressId) {
      try {
        const response = await axios.post(
          `${BASE_URL_USER}/api/v1/user/update-address?addressId=${addressId}`,
          values,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data) {
          toast({
            title: "Address Updated Successfully",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          resetForm();
          setIsOpen(false);
          setReload(!reload);
          setFormData(initialValues);
          setIsEdit(false);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          toast({
            title:
              error?.response?.data?.errors[0]?.appMessage || "Bad Request",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        } else {
          toast({
            title: "Something Went Wrong",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        }
        resetForm();
        setFormData(initialValues);
        setIsEdit(false);
      }
    }
  };

  async function updateUserAddress(addressId, showToast = false) {
    try {
      const response = await axios.post(
        `${BASE_URL_FLORAHUB}/order/api/v1/order`,
        {
          orderType: "CART",
          orderId: orderId,
          addessessId: addressId,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        resetForm();
        setIsOpen(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast({
          title: error?.response?.data?.errors[0]?.appMessage || "Bad Request",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something Went Wrong",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      }
      setIsAddressSelect(false);
    }
  }

  async function deleteUserAddress(addressId) {
    try {
      const response = await axios.delete(
        `${BASE_URL_USER}/public-api/v1/user/delete-address?addressId=${addressId}`,
        {
          addessessId: +addressId,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        toast({
          title: "Address Deleted",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        setReload(!reload);
        setDeleteModal({ open: false, id: null });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast({
          title: error?.response?.data?.errors[0]?.appMessage || "Bad Request",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something Went Wrong",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      }
    }
  }

  useEffect(() => {
    if (selectedAddress) {
      updateUserAddress(selectedAddress, false);
    } else {
      data.forEach((address) => {
        if (address.default) {
          setSelectedAddress(address.id);
          updateUserAddress(address.id);
          setIsAddressSelect(true);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress, data]);

  return (
    <div>
      {/* <p className='text-xl text-left my-2 pl-2 font-medium py-2'>1. Select a delivery address</p> */}

      <div className="text-left p-3 bg-white  border border-gray-200 rounded-lg shadow">
        <div className="p-2">
          <p className="font-semibold -mt-2">Your addresses</p>
          {data?.map((address) => {
            return (
              <div
                key={address.id}
                className="flex items-center justify-between"
              >
                <div className="flex items-center">
                  <div>
                    <input
                      type="radio"
                      name="address"
                      className="form-radio h-4 w-4 text-indigo-600 border-gray-300 mt-3 "
                      // eslint-disable-next-line eqeqeq
                      checked={selectedAddress == address.id}
                      onChange={handleRadioChange}
                      value={address.id}
                    />
                  </div>
                  <div>
                    <label className="ml-2">
                      <div>
                        <span className="pl-3 font-bold">
                          {" "}
                          {`${address?.contactPersonName}`}{" "}
                        </span>
                        <span className="pl-3 font-semibold">
                          {" "}
                          {`${address?.addressUnit}`}{" "}
                        </span>
                        <span className="pl-3 font-semibold">
                          {" "}
                          {`${address?.contactNo}`}{" "}
                        </span>
                        <span className=" px-2 font-light bg-zinc-600 text-white rounded-2xl">
                          {" "}
                          {`${address?.addressType}`}{" "}
                        </span>
                      </div>
                      <div className="ml-3 text-gray-400">
                        {`${address?.landmark} ${address?.locality} ${address?.city} ${address?.state} Pin- ${address?.pincode}`}
                      </div>
                    </label>
                  </div>
                </div>
                <div>
                  <div className="flex">
                    {/* Edit Functionality */}
                    <div>
                      <div
                        className="cursor-pointer mr-2"
                        onClick={() => {
                          setFormData({
                            contactPersonName: address?.contactPersonName || "",
                            contactNo: address?.contactNo || "",
                            addressType: address?.addressType || "",
                            addressUnit: address?.addressUnit || "",
                            locality: address?.locality || "",
                            landmark: address?.landmark || "",
                            city: address?.city || "",
                            state: address?.state || "",
                            pincode: address?.pincode || "",
                            default: address?.default || false,
                          });
                          setAddressId(address.id);
                          setIsEdit(true);
                          setIsOpen(true);
                        }}
                      >
                        <FaPencil className="hover:text-orange-500" size={18} />
                      </div>
                    </div>

                    {/* Delete Functionality */}
                    <div>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setDeleteModal({
                            open: true,
                            id: address.id,
                          });
                        }}
                      >
                        <FaRegTrashCan
                          className="hover:text-red-800"
                          size={18}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div
            className={`mt-3 -ml-2 ${data.length >= 5 ? "hidden" : "block   "}`}
          >
            <CustomButton
              size="small"
              className=" !bg-transparent !text-black "
              iconLeft={<FaPlus className="inline -mt-2" size={20} />}
              onClick={() => {
                setIsOpen(true);
              }}
            >
              Add a new Address
            </CustomButton>
          </div>
        </div>

        <Modal
          blockScrollOnMount={true}
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            setIsEdit(false);
            setAddressId(null);
            setFormData(initialValues);
            resetForm();
          }}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Address Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <div>
                <form onSubmit={handleSubmit}>
                  <DeliveryForm
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    formDisable={formDisable}
                    setFormDisable={setFormDisable}
                    profileData={profileData}
                    isEdit={isEdit}
                  />
                  <div className="flex items-end justify-end">
                    <CustomButton
                      disabled={formDisable}
                      type="submit"
                      className="w-3/6"
                    >
                      {isEdit ? "Update Address" : "Add Address"}
                    </CustomButton>
                  </div>
                </form>
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>

        <Modal
          blockScrollOnMount={true}
          isOpen={deleteModal.open}
          onClose={() => {
            setDeleteModal({ open: false, id: null });
          }}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              <div className="p-4">
                <div className="mt-4">
                  <p className="font-semibold text-xl text-center">
                    Are you sure you want to delete this address ?{" "}
                  </p>
                </div>
                <div className="flex items-end justify-end mt-4">
                  <CustomButton
                    onClick={() => {
                      setDeleteModal({ open: false, id: null });
                    }}
                    className="mr-4"
                  >
                    Cancel
                  </CustomButton>
                  <CustomButton
                    onClick={() => {
                      deleteUserAddress(deleteModal.id);
                    }}
                    className="bg-red-600 hover:bg-red-800"
                  >
                    Confirm
                  </CustomButton>
                </div>
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
};

export default Delivery;
